import { FC } from "react";
import { Snackbar, Alert } from "@mui/material";

interface Props {
  open: boolean;
  messageList: string[];
  type?: "error" | "success";
  style?: any;
  onClose: () => void;
}

const autoHideDuration = 3000

const NoticeBanner: FC<Props> = ({
  open,
  messageList,
  type = "success",
  style,
  onClose,
}) => {

  const messages = () => {
    return messageList.map((message: string, index: number)=> (
      <p style={{ margin: 0 }} key={`${type}_${index}`}>
        {message}
      </p>
    ))
  }

  return (
    <div style={styles.container}>
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        sx={style ?? styles.noticeBanner}
        onClose={() => onClose()}
      >
        <Alert
          severity={type}
          sx={styles.notice}
          onClose={onClose}
        >
          {messages()}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NoticeBanner;

const styles = {
  noticeBanner: {
    width: "100%",
    display: "block",
    position: "initial",
  },

  notice: {
    width: "100%",
  },

  container: {
    position: "fixed" as const,
    left: "5%",
    width: "90%",
    bottom: "12px",
    zIndex: 9999
  }
}